import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function StillForRent({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
    setIsDisabled(true);

        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>

          <Col span={24}>
            <h2 className="green-heading">
              If the home is still for rent check this item and mark the
              checklist complete. you will get a reminder follow up in 2 weeks
              to check with the owner again.
            </h2>
          </Col>
          <Col span={24}>
            <h1 className="red-heading">
              If the home has been on the market for 60 days or more please send
              the following to the owner.
            </h1>
          </Col>
          <Col span={24}>
            <h3 className="green-heading">
              -download the tenant turner showing report for interest
            </h3>
          </Col>
          <Col span={24}>
            <h3 className="green-heading">
              -review applications submitted to date for the property in
              question using this link
            </h3>
          </Col>
          <Col span={24}>
            <h3 className="blue-heading">
              - application reportapplicant we can approve. If you are ready to
              make a price change just let us know and we can get it adjusted
              now! We generally recommend between a $25 and $50 price drop. You
              also may want to consider our Security Deposit alternative
              offering if you do not already have that on your listing. Let me
              know if you need more info on that.
            </h3>
          </Col>
          <Col span={24}>
            <h3 className="blue-heading">
              -send the email below please EDIT TO FIT THE SITUATION
            </h3>
          </Col>
          <Col span={24}>
            <h3>
              send this email to the owner in appfolio - include the property
              address in the subject line if there are no viable applications
              processing.
            </h3>
          </Col>
          <Col span={24}>
            <p>
              Your property has now been on the market for an extended period. I
              have attached a copy of the feedback and showings we have had to
              date on the property. This should help you get an idea of the
              interest we have had to date. I have also reviewed the
              applications we have had so far. I have_______
              <strong className="red-info-heading">
                Please add your feedback on applicants here ie i have had quite
                a few that do not meet our minimum requirements or I have not
                had any applicants etc
              </strong>
              _________
            </p>
          </Col>
          <Col span={24}>
            <p>
              At this point we highly recommend a price change. This will help
              to generate renewed interest and potentially an applicant we can
              approve. If you are ready to make a price change just let us know
              and we can get it adjusted now! We generally recommend between a
              $25 and $50 price drop. You also may want to consider our Security
              Deposit alternative offering if you do not already have that on
              your listing. Let me know if you need more info on that.
            </p>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" onClick={handleComplete} disabled={isDisabled}>Completed</Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default StillForRent;
